/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  AlertPreferenceDto,
  AlertsAdminListEventsParams,
  ApiEnvelopeAlertEventListDto,
  ApiEnvelopeAlertMetricCurrentListDto,
  ApiEnvelopeAlertPreferenceDto,
  ApiEnvelopeAlertRuleDto,
  ApiEnvelopeAlertRuleListDto,
  ApiEnvelopeAlertTestResultDto,
  ApiEnvelopeBoolean,
  CreateAlertRuleRequest,
  UpdateAlertRuleRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type alertsAdminListRulesResponse200 = {
  data: ApiEnvelopeAlertRuleListDto
  status: 200
}

export type alertsAdminListRulesResponseSuccess = (alertsAdminListRulesResponse200) & {
  headers: Headers;
};
;

export type alertsAdminListRulesResponse = (alertsAdminListRulesResponseSuccess)

export const getAlertsAdminListRulesUrl = () => {




  return `/api/admin/alerts/rules`
}

export const useAlertsAdminListRulesHook = (): ( options?: RequestInit) => Promise<alertsAdminListRulesResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getAlertsAdminListRulesUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type alertsAdminCreateRuleResponse200 = {
  data: ApiEnvelopeAlertRuleDto
  status: 200
}

export type alertsAdminCreateRuleResponse400 = {
  data: ApiEnvelopeAlertRuleDto
  status: 400
}

export type alertsAdminCreateRuleResponseSuccess = (alertsAdminCreateRuleResponse200) & {
  headers: Headers;
};
export type alertsAdminCreateRuleResponseError = (alertsAdminCreateRuleResponse400) & {
  headers: Headers;
};

export type alertsAdminCreateRuleResponse = (alertsAdminCreateRuleResponseSuccess | alertsAdminCreateRuleResponseError)

export const getAlertsAdminCreateRuleUrl = () => {




  return `/api/admin/alerts/rules`
}

export const useAlertsAdminCreateRuleHook = (): (createAlertRuleRequest?: CreateAlertRuleRequest, options?: RequestInit) => Promise<alertsAdminCreateRuleResponse> => {

      const customFetcher = useSfetchMutator();
      return (createAlertRuleRequest?: CreateAlertRuleRequest, options?: RequestInit) => {

        return customFetcher(getAlertsAdminCreateRuleUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createAlertRuleRequest)
  }
);
      }
  }


export type alertsAdminUpdateRuleResponse200 = {
  data: ApiEnvelopeAlertRuleDto
  status: 200
}

export type alertsAdminUpdateRuleResponse404 = {
  data: ApiEnvelopeAlertRuleDto
  status: 404
}

export type alertsAdminUpdateRuleResponseSuccess = (alertsAdminUpdateRuleResponse200) & {
  headers: Headers;
};
export type alertsAdminUpdateRuleResponseError = (alertsAdminUpdateRuleResponse404) & {
  headers: Headers;
};

export type alertsAdminUpdateRuleResponse = (alertsAdminUpdateRuleResponseSuccess | alertsAdminUpdateRuleResponseError)

export const getAlertsAdminUpdateRuleUrl = (id: string,) => {




  return `/api/admin/alerts/rules/${id}`
}

export const useAlertsAdminUpdateRuleHook = (): (id: string,
    updateAlertRuleRequest?: UpdateAlertRuleRequest, options?: RequestInit) => Promise<alertsAdminUpdateRuleResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    updateAlertRuleRequest?: UpdateAlertRuleRequest, options?: RequestInit) => {

        return customFetcher(getAlertsAdminUpdateRuleUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateAlertRuleRequest)
  }
);
      }
  }


export type alertsAdminDeleteRuleResponse200 = {
  data: ApiEnvelopeBoolean
  status: 200
}

export type alertsAdminDeleteRuleResponse404 = {
  data: ApiEnvelopeBoolean
  status: 404
}

export type alertsAdminDeleteRuleResponseSuccess = (alertsAdminDeleteRuleResponse200) & {
  headers: Headers;
};
export type alertsAdminDeleteRuleResponseError = (alertsAdminDeleteRuleResponse404) & {
  headers: Headers;
};

export type alertsAdminDeleteRuleResponse = (alertsAdminDeleteRuleResponseSuccess | alertsAdminDeleteRuleResponseError)

export const getAlertsAdminDeleteRuleUrl = (id: string,) => {




  return `/api/admin/alerts/rules/${id}`
}

export const useAlertsAdminDeleteRuleHook = (): (id: string, options?: RequestInit) => Promise<alertsAdminDeleteRuleResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getAlertsAdminDeleteRuleUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type alertsAdminListEventsResponse200 = {
  data: ApiEnvelopeAlertEventListDto
  status: 200
}

export type alertsAdminListEventsResponseSuccess = (alertsAdminListEventsResponse200) & {
  headers: Headers;
};
;

export type alertsAdminListEventsResponse = (alertsAdminListEventsResponseSuccess)

export const getAlertsAdminListEventsUrl = (params?: AlertsAdminListEventsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/alerts/events?${stringifiedParams}` : `/api/admin/alerts/events`
}

export const useAlertsAdminListEventsHook = (): (params?: AlertsAdminListEventsParams, options?: RequestInit) => Promise<alertsAdminListEventsResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: AlertsAdminListEventsParams, options?: RequestInit) => {

        return customFetcher(getAlertsAdminListEventsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type alertsAdminCurrentMetricsResponse200 = {
  data: ApiEnvelopeAlertMetricCurrentListDto
  status: 200
}

export type alertsAdminCurrentMetricsResponseSuccess = (alertsAdminCurrentMetricsResponse200) & {
  headers: Headers;
};
;

export type alertsAdminCurrentMetricsResponse = (alertsAdminCurrentMetricsResponseSuccess)

export const getAlertsAdminCurrentMetricsUrl = () => {




  return `/api/admin/alerts/metrics/current`
}

export const useAlertsAdminCurrentMetricsHook = (): ( options?: RequestInit) => Promise<alertsAdminCurrentMetricsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getAlertsAdminCurrentMetricsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type alertsAdminGetPreferencesResponse200 = {
  data: ApiEnvelopeAlertPreferenceDto
  status: 200
}

export type alertsAdminGetPreferencesResponseSuccess = (alertsAdminGetPreferencesResponse200) & {
  headers: Headers;
};
;

export type alertsAdminGetPreferencesResponse = (alertsAdminGetPreferencesResponseSuccess)

export const getAlertsAdminGetPreferencesUrl = () => {




  return `/api/admin/alerts/preferences`
}

export const useAlertsAdminGetPreferencesHook = (): ( options?: RequestInit) => Promise<alertsAdminGetPreferencesResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getAlertsAdminGetPreferencesUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type alertsAdminSetPreferencesResponse200 = {
  data: ApiEnvelopeAlertPreferenceDto
  status: 200
}

export type alertsAdminSetPreferencesResponseSuccess = (alertsAdminSetPreferencesResponse200) & {
  headers: Headers;
};
;

export type alertsAdminSetPreferencesResponse = (alertsAdminSetPreferencesResponseSuccess)

export const getAlertsAdminSetPreferencesUrl = () => {




  return `/api/admin/alerts/preferences`
}

export const useAlertsAdminSetPreferencesHook = (): (alertPreferenceDto?: AlertPreferenceDto, options?: RequestInit) => Promise<alertsAdminSetPreferencesResponse> => {

      const customFetcher = useSfetchMutator();
      return (alertPreferenceDto?: AlertPreferenceDto, options?: RequestInit) => {

        return customFetcher(getAlertsAdminSetPreferencesUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(alertPreferenceDto)
  }
);
      }
  }


export type alertsAdminSendTestResponse200 = {
  data: ApiEnvelopeAlertTestResultDto
  status: 200
}

export type alertsAdminSendTestResponseSuccess = (alertsAdminSendTestResponse200) & {
  headers: Headers;
};
;

export type alertsAdminSendTestResponse = (alertsAdminSendTestResponseSuccess)

export const getAlertsAdminSendTestUrl = () => {




  return `/api/admin/alerts/test`
}

export const useAlertsAdminSendTestHook = (): ( options?: RequestInit) => Promise<alertsAdminSendTestResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getAlertsAdminSendTestUrl(),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


